import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import {
 getDocumentApprovedList,
  IMG_BASE_URL,
} from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'

const DocumentApprovedList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [loading, setLoading] = useState(false)

  const [rejectModalOpen, setRejectModalOpen] = useState(false)
  const [rejectReason, setRejectReason] = useState('')


  useEffect(() => {
    fetchDocumentApprovedList()
  }, [])

  const fetchDocumentApprovedList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${getDocumentApprovedList}/${storedBranchId}/${BoardingYear}`,
      )


      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || "-",
        document_approval_date : item.documents.document_approval_date || "-",
        
        full_data: item,
      }));

      setData(formatted);

      console.log(res.data);
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
    { title: 'Document Approve Date', dataIndex: 'document_approval_date' },
 
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]


//   const handleApproval = async () => {
//   if (!selectedRecord) return;

//   const body = {
//     reg_id: parseInt(selectedRecord.reg_id),
//     document_approval: 2,
//   };

//   try {
//     setLoading(true);

//     const res = await axios.post(DocumentApproveReject, body);

//     if (res.data === "APPROVED") {
//       toast.success("Document Approved Successfully");

//       setViewModalOpen(false);
//       setConfirmChecked(false);

//       fetchDocumentAppPendingList();
//     } else {
//       toast.error("Approval failed");
//     }
//   } catch (err) {
//     console.log(err);
//     toast.error("Something went wrong");
//   } finally {
//     setLoading(false);
//   }
// };

//   // const handleRejectSubmit = async () => {
//   //   if (!selectedRecord) return

//   //   const body = {
//   //     reg_id: parseInt(selectedRecord.reg_id),
//   //     hostelPay_approval: 3,
//   //     reject_reason: rejectReason.trim(),
//   //   }

//   //   try {
//   //     setLoading(true)
//   //     const res = await axios.put(FeeApproveReject, body)

//   //     toast.success('Application Rejected Successfully')

//   //     // Reset all states
//   //     setRejectModalOpen(false)
//   //     setRejectReason('')
//   //     setConfirmChecked(false)

//   //     fetchFeeAppPendingList()
//   //   } catch (err) {
//   //     toast.error('Failed to reject application')
//   //   } finally {
//   //     setLoading(false)
//   //   }
//   // }



//   // =======CSS==========
  
  
//   const handleRejectSubmit = async () => {
//   if (!selectedRecord) return;

//   const body = {
//     reg_id: parseInt(selectedRecord.reg_id),
//     document_approval: 3,
//     reject_reason: rejectReason.trim(),
//   };

//   try {
//     setLoading(true);

//     const res = await axios.post(DocumentApproveReject, body);

//     if (res.data === "REJECTED") {
//       toast.success("Document Rejected Successfully");

//       setRejectModalOpen(false);
//       setRejectReason("");
//       setConfirmChecked(false);

//       fetchDocumentAppPendingList();
//     } else {
//       toast.error("Rejection failed");
//     }
//   } catch (err) {
//     console.log(err);
//     toast.error("Something went wrong");
//   } finally {
//     setLoading(false);
//   }
// };
  
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Full Name': item.full_name,
      'WhatsApp No': item.whats_no,
      'Document Approve date' : item.documents.document_approval_date,
        'Status' : "Approved"
    }))
    
    
    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 35 },
      { wch: 18 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
    ]


    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Hostel Fee Approval Pending',
    )

    XLSX.writeFile(workbook, 'Hostel_Fee_Approval_Pending_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Document Approved List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => {
          setViewModalOpen(false)
          setConfirmChecked(false)
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* ========= PERSONAL INFORMATION ========== */}
              <h6 style={titleText}>- Personal Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12 col-md-3">
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.s_pic}`}
                      alt="Profile Picture"
                      className="rounded-circle img-fluid rounded border"
                      style={{
                        width: '160px',
                        height: '160px',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-9">
                    <div className="row">
                      <div className="col-md-12 py-1">
                        <span style={labelCss}>Full Name:</span>
                        <br />
                        <span
                          style={{
                            backgroundColor: '#f8ff90',
                            padding: '2px 10px',
                            fontSize: '16px',
                          }}
                        >
                          {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                          {selectedRecord.s_lname}
                        </span>
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Mobile:</span>
                        <br /> {selectedRecord.mobile}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>WhatsApp No:</span>
                        <br /> {selectedRecord.wh_mobile || '-'}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Email:</span>
                        <br /> {selectedRecord.email}
                      </div>
                      <div className="col-md-8 py-1">
                        <span style={labelCss}>Address:</span>
                        <br /> {selectedRecord.address},{' '}
                        {selectedRecord.village}
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              {/* ========= UPLOADED DOCUMENTS ========== */}
              <>
                <h6 style={titleText}>- Uploaded Documents :</h6>
                
                <div className="card shadow-sm p-4 mb-4">
                  <h5 className="mb-3" style={{ color: '#235784' }}>
                    Documents -
                  </h5>

                  <div className="row text-center">
                    {Object.entries({
                      'Aadhar Card': selectedRecord?.documents?.s_aadhar,
                      '10th / 12th Leaving Certificate':
                        selectedRecord?.documents?.cast_income_cert,
                      'Recommendation Letter':
                        selectedRecord?.documents?.recommendation_letter,
                      'College Admission Receipt':
                        selectedRecord?.documents?.clg_add_receipt,
                    }).map(([label, fileName]) => {
                      const imgSrc = fileName ? IMG_BASE_URL + fileName : null

                      return (
                        <div
                          className="col-12 col-md-6 col-lg-4 mb-3 mt-3 pb-4"
                          style={{ border: '1px solid #b8b8b8ff' }}
                          key={label}
                        >
                          <p className="fw-semibold mb-1">{label}</p>

                          {imgSrc ? (
                            fileName.toLowerCase().endsWith('.pdf') ? (
                              <iframe
                                src={imgSrc}
                                title={label}
                                width="100%"
                                height="300px"
                                style={{
                                  border: '1px solid #ccc',
                                  borderRadius: '6px',
                                }}
                              />
                            ) : (
                              <img
                                src={imgSrc}
                                alt={label}
                                className="img-fluid rounded border"
                                style={{
                                  width: '100%',
                                  objectFit: 'contain',
                                  display: 'block',
                                }}
                              />
                            )
                          ) : (
                            <p className="text-muted">No File</p>
                          )}

                          {imgSrc && fileName.toLowerCase().endsWith('.pdf') && (
                            <a
                              href={imgSrc}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-primary mt-2"
                            >
                              Download PDF
                            </a>
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </>
            </div>
            
          </div>
        )}
      </Modal>

    </div>
  )
}

export default DocumentApprovedList;
